import type { AccessibleFleet, UUID } from '@cobliteam/common-types';

/**
 * A dica de trocar de frota só faz sentido quando existe **outra** frota ativa para ir.
 *
 * A sessão é a fonte da verdade sobre a frota atual estar inativa; a lista do `getUserData` vem
 * de outro resolver e pode discordar (dado velho, ou falha parcial numa sessão sem
 * `basic:permission`). Sem excluir a frota da sessão, uma lista que devolva a própria frota como
 * ativa faz o banner oferecer "troque de frota" apontando para a frota em que o usuário já está.
 */
const hasActiveFleetToSwitch = (sessionFleetId: UUID, userFleets: AccessibleFleet[] | undefined): boolean =>
  (userFleets ?? []).some((fleet) => fleet.id !== sessionFleetId && fleet.active !== false);

export default hasActiveFleetToSwitch;
